import { render } from "./MerchantOperators.vue?vue&type=template&id=5653e2b4&ts=true"
import script from "./MerchantOperators.vue?vue&type=script&lang=ts"
export * from "./MerchantOperators.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__